import {formatDate, formatTime} from "@/src/modules/core/lib/formatters";

import type {Citation, CitationFile} from "../types";

export function getCitationTowDispatchFiles(citation: Citation): CitationFile[] {
  const dispatch = citation.tow?.dispatch;
  if (!dispatch?.files?.length) return [];
  return dispatch.files;
}

export function getCitationProofSectionTitle(citation: Citation): string {
  const at = citation.citation_proof?.created_at;
  if (!at) return "Proof";
  return `Proof submitted on ${formatDate(at)} ${formatTime(at)}`;
}

export function getCitationTowProofSectionTitle(citation: Citation): string {
  const dispatch = citation.tow?.dispatch;
  if (!dispatch) return "Tow proof";

  if (citation.tow?.completed && dispatch.updated_at) {
    return `Tow proof completed on ${formatDate(dispatch.updated_at)} ${formatTime(dispatch.updated_at)}`;
  }
  if (dispatch.requested_at) {
    return `Tow proof requested on ${formatDate(dispatch.requested_at)} ${formatTime(dispatch.requested_at)}`;
  }
  return "Tow proof";
}
